function _datetimeNow() {
  try {
    return new Date().toISOString();
  } catch (err) {
    return null;
  }
}

export default _datetimeNow;
